import { exportToExcel, exportToPDF } from '../../../../../../src/utils/exportUtils';
import { ReportLevel, TableColumn } from './tableUtils';

export const createExportHandlers = (
  currentLevel: ReportLevel,
  filteredData: any[],
  getTableColumns: (level: ReportLevel) => TableColumn[],
  onSuccess: (message: string) => void,
  onError: (message: string) => void
) => {
  const handleExportExcel = async () => {
    try {
      const exportColumns = getTableColumns(currentLevel);
      const fileName = `meal-report-${currentLevel}-${new Date().toISOString().split('T')[0]}.xlsx`;
      exportToExcel(filteredData, exportColumns, fileName);
      onSuccess('Report exported to Excel successfully');
    } catch (error) {
      console.error('Export error:', error);
      onError('Failed to export report');
    }
  };

  const handleExportPDF = async () => {
    try {
      const exportColumns = getTableColumns(currentLevel);
      const fileName = `meal-report-${currentLevel}-${new Date().toISOString().split('T')[0]}.pdf`;
      exportToPDF(filteredData, exportColumns, fileName);
      onSuccess('Report exported to PDF successfully');
    } catch (error) {
      console.error('Export error:', error);
      onError('Failed to export report');
    }
  };

  return {
    onExportExcel: handleExportExcel,
    onExportPDF: handleExportPDF,
  };
};
